<template>
  <SogPage
    id="page"
    title="Stornierung (beta)"
  >
    <SogCard>
      <SogCardTitle>{{ _insuranceCancelation?.insuranceNumber }}</SogCardTitle>
      <SogCardActions :is-toolbar="true">
        <SogCardActionButton
          :kind="SogButtonKind.Refresh"
          @click="refresh()"
        />
        <SogCardActionButton
          :kind="SogButtonKind.Back"
        />
      </SogCardActions>
      <SogCardContent v-show="!_loadDetails">
        <InsuranceCancelationDetailsComponent :data="_insuranceCancelation" />
      </SogCardContent>
      <SogCardContent>
        <SogSkeleton v-show="_loadDetails" />
      </SogCardContent>
    </SogCard>
    <SogCard v-show="_loadHistory||_history.length>0">
      <SogCardTitle>Historie</SogCardTitle>
      <SogCardContent v-show="!_loadHistory">
        <HistoryListComponent :data="_history" />
      </SogCardContent>
      <SogCardContent>
        <SogSkeleton v-show="_loadHistory" />
      </SogCardContent>
    </SogCard>
  </SogPage>
</template>

<script setup lang="ts">

import SogPage from "@/shared/ui/SogPage.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogSkeleton from "@/shared/ui/SogSkeleton.vue";
import {onMounted, ref, reactive} from "vue";
import apiInsuranceCancelation from "@/modules/InsuranceCancelation/api";
import InsuranceCancelation from "@/shared/model/InsuranceCancelation";
import {useNavigationStore} from "@/modules/Navigation/store";
import InsuranceCancelationDetailsComponent
  from "@/modules/InsuranceCancelation/components/InsuranceCancelationDetailsComponent.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import HistoryListComponent from "@/modules/History/components/HistoryListComponent.vue";
import apiHistory from "@/modules/History/api";
import History from "@/shared/model/History";
import getGuid from "@/shared/utils/getGuid";

interface Props {
  id?: string
}

const props = withDefaults(defineProps<Props>(), {
      id: undefined
    }
)


const _insuranceCancelationId = ref<string | undefined>(undefined)
const _loadDetails = ref(false)
const _key = ref("")
const _insuranceCancelation = ref<InsuranceCancelation | undefined>(undefined)
const _navigationStore = useNavigationStore()
const _loadHistory = ref(false)
const _history: History[] = reactive<History[]>([])


async function load() {

  if (!props.id) {
    return;
  }
  _insuranceCancelationId.value = props.id

  _key.value = getGuid();
  const t_loadDetails = loadDetails(_key.value);
  const t_loadHistory = loadHistory(_key.value);

  await Promise.allSettled([t_loadDetails, t_loadHistory])
}

async function loadDetails(key: string) {
  if (!_insuranceCancelationId.value)
    return
  _loadDetails.value = true
  const res = await apiInsuranceCancelation.load(_insuranceCancelationId.value)
  if (_key.value !== key) {
    return
  }
  if (res) {
    _insuranceCancelation.value = res.insuranceCancelation
  }
  _loadDetails.value = false
}

async function loadHistory(key: string) {
  if (!_insuranceCancelationId.value)
    return
  _loadHistory.value = true
  _history.length = 0
  const lst = await apiHistory.listInsuranceCancelation(_insuranceCancelationId.value)
  if (_key.value !== key) {
    return
  }
  if (lst) {
    _history.push(...lst)
  }
  _loadHistory.value = false
}

async function refresh() {
  await load();
}

onMounted(() => {
  if (!props.id) {
    _navigationStore.back()
    return;
  }
  load()
})
</script>

<style scoped>

</style>
